module.exports = (formValues, requiredFields) => {
  let errors = {}; // Store errors by key: { "phone-number-0": "duplicate" }
  let phoneNumbers = {}; // Track value -> first key found

  for (let key in formValues) {
    // 1. Check Required Fields
    requiredFields.forEach((field) => {
      if (key.includes(field)) {
        if (!formValues[key] || formValues[key] === '') {
          errors[key] = 'incomplete';
        }
      }
    });

    // 2. Check Duplicates for Phone Numbers
    if (key.includes("phone-number")) {
      const val = formValues[key]?.toString().trim();
      if (val && val !== "") {
        if (phoneNumbers[val]) {
          // Mark both the current key AND the original key as duplicates
          errors[key] = 'duplicate';
          errors[phoneNumbers[val]] = 'duplicate';
        } else {
          phoneNumbers[val] = key;
        }
      }
    }
  }

  return {
    isValid: Object.keys(errors).length === 0,
    errors: errors
  };
};